import React from 'react';
import '../styles/OverviewStep.css';
import '../styles/GeneralStyles.css';
import imgCover from '../assets/img-cover.jpg'
import logoTressor from '../assets/logo-tressor.png'

const OverviewStep = ({ nextStep }) => {
  return (
    <div className='container-large'>
        <div className='wrapp-principal-2-columns'>
            
                <div className="column-content-start">
                  <div className='text-n-options'>
                    <img src={logoTressor} alt="logo Tressor" className='logo-tressor' />
                  <h1 className='heading-style-h2 text-align-center '>Diseña el Anillo de Compromiso de sus sueños</h1>
                  <p className='text-size-large text-color-grey text-align-center'>de manera rápida y sencilla en 6 pasos</p>
                    
                  </div>
                    
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                    <button 
                      className="button"
                      onClick={nextStep}
                    >
                      COTIZAR TU ANILLO
                    </button>

                    </div>
                    
                </div>
                <div className="column-image">
                  <img 
                    src={imgCover} 
                    alt="Formulario ilustración"
                    className='imgPreviewNoText'
                  />
                </div>
          
        </div>
    
    </div>
    
  );
};

export default OverviewStep;
